<div class="row">
  <div class="col-sm-12">
    <h4>Berichtseinträge</h4>
    <ul></ul>
    @for (report of reports; track report.id) {
      <li>
        {{ report.createdDate | date: "dd.MM.yyy HH:mm" : undefined : "de-AT" }}:
        <span [innerHTML]="report.details"></span>
      </li>
    } @empty {
      <div
        class="alert alert-info"
        role="alert">
        Keine Berichte vorhanden!
      </div>
    }
  </div>
</div>
